import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });

// Custom error thrown when /api/* returns a 402 (paywall).
export class SubscriptionRequiredError extends Error {
  constructor(detail) {
    super(detail?.message || "Subscription required");
    this.name = "SubscriptionRequiredError";
    this.detail = detail || {};
  }
}

http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      return Promise.reject(new SubscriptionRequiredError(err.response.data));
    }
    return Promise.reject(err);
  },
);

export const api = {
  me: () => http.get("/me").then(r => r.data),
  createChild: (payload) => http.post("/children", payload).then(r => r.data),
  generateJourney: (childId, kind = null) =>
    http.post("/journeys/generate", {
      child_id: childId,
      ...(kind ? { kind } : {}),
    }).then(r => r.data),
  getJourney: (journeyId) => http.get(`/journeys/${journeyId}`).then(r => r.data),
  completeMission: (journeyId, missionId, secondsTaken = 0) =>
    http.post(`/journeys/${journeyId}/missions/${missionId}/complete`, {
      seconds_taken: Math.max(0, Math.round(secondsTaken)),
    }).then(r => r.data),
  submitFeedback: (payload) => http.post("/feedback", payload).then(r => r.data),
  submitWrapUp: (journeyId, payload) =>
    http.post(`/journeys/${journeyId}/wrap-up`, payload).then(r => r.data),
  uploadMissionPhoto: (journeyId, missionId, file, caption) => {
    const fd = new FormData();
    fd.append("photo", file);
    if (caption) fd.append("caption", caption);
    return http.post(
      `/journeys/${journeyId}/missions/${missionId}/photo`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } },
    ).then(r => r.data);
  },
};
